// Official brand logos, normalised to a uniform white monochrome treatment
// for the dark, cinematic aesthetic. Files live in /public/logos.
// `h` is the rendered logo height in px (tuned per logo so optical weight matches).
export const BRAND_LOGOS = [
  { name: "Reolink", file: "/logos/reolink.png", h: 26 },
  { name: "Einhell", file: "/logos/einhell.png", h: 26 },
  { name: "Soprema", file: "/logos/soprema.png", h: 42 },
  { name: "Barbot", file: "/logos/barbot.png", h: 46 },
  { name: "Bluetti", file: "/logos/bluetti.png", h: 24 },
  { name: "Allpowers", file: "/logos/allpowers.png", h: 18 },
];
